
import React, { useState, useEffect } from 'react';
import TextField from './formwidgets/TextField';
import Checkbox from './formwidgets/Checkbox';
import Radio from './formwidgets/Radio';
import Select from './formwidgets/Select';
import WeekTimeAvailability from './formwidgets/WeekTimeAvailability';
import Ckeditor from './formwidgets/Ckeditor';

export default function GasFormField({op, fieldOptions, value, index, onChange}) {

    let content = null;

    //controllo se il field non può essere editato in edit
    let noEdit = (fieldOptions.noeditpwa && fieldOptions.noeditpwa === true && op === "edit") || op === "show";
    //controllo se il field non può essere mai editato
    let onlyShow = fieldOptions.onlyshowpwa && fieldOptions.onlyshowpwa === true;

    let otherOptions = {
        name: index,
        value,
        onChange,
        required: fieldOptions.validate?.includes("required"),
        disabled: noEdit || onlyShow,
    }
   
    switch(fieldOptions.widget) {
        case "textfield":
        case "textarea":
        default:
            if(fieldOptions.hasOwnProperty("ckeditor") && fieldOptions.ckeditor === true) {
                // Se il widget è ckeditor, non usare TextField ma un componente specifico
                content = <Ckeditor {...{...fieldOptions, ...otherOptions}}/>;
            }else{
                content = <TextField {...{...fieldOptions, ...otherOptions}}/>;
            }
            break;
        case "singlecheckbox":
            content = <Checkbox {...{...fieldOptions, ...otherOptions}}/>;
            break;
        case "radio":    
            content = <Radio {...{...fieldOptions, ...otherOptions}}/>;
            break;
        case "select":    
            content = <Select {...{...fieldOptions, ...otherOptions}}/>;
            break;
        case "week-time-availability":
            content = <WeekTimeAvailability {...{...fieldOptions, ...otherOptions}}/>;
            break;    
            
    }

    return content;
}